import React, { PropsWithChildren, VoidFunctionComponent } from 'react';
import {
  CardListItem,
  CardListItemProps
} from 'record-it-components/cardList/CardListItem/CardListItem';
import { CardListItemIconButton } from 'record-it-components/cardList/CardListItemIconButton/CardListItemIconButton';
import { CardListItemTitle } from 'record-it-components/cardList/CardListItemTitle/CardListItemTitle';
import { useModalOpened } from 'record-it-components/hooks/useModalOpened/useModalOpened';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { UserGroup } from '../../../classes/entities/UserGroup/userGroupTypes';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';
import { useUserGroupDeleteHandler } from '../../../hooks/entity/deleteHandler/useUserGroupDeleteHandler';
import { EditUserGroupDialog } from '../EditUserGroupDialog/EditUserGroupDialog';

export type UserGroupListItemProps = PropsWithChildren<CardListItemProps> & {
  userGroup: UserGroup;
};

export const UserGroupListItem: VoidFunctionComponent<UserGroupListItemProps> =
  React.memo((props) => {
    const { userGroup, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });

    const {
      open: openEditDialog,
      close: closeEditDialog,
      modalProps
    } = useModalOpened({ closeOnBackDropClick: true });

    const handleDeleteClick = useUserGroupDeleteHandler(userGroup);

    return (
      <>
        <CardListItem {...remainingProps}>
          <CardListItemTitle>{userGroup.name}</CardListItemTitle>
          <CardListItemIconButton
            {...iconConfigurations.prefixed.listItem.deleteIcon}
            onClick={handleDeleteClick}
            data-testid="UserGroupListItem.DeleteButton"
          ></CardListItemIconButton>
          <CardListItemIconButton
            {...iconConfigurations.prefixed.listItem.editInDialogIcon}
            onClick={openEditDialog}
          ></CardListItemIconButton>
        </CardListItem>
        <EditUserGroupDialog
          {...modalProps}
          userGroup={userGroup}
          onAccept={closeEditDialog}
        ></EditUserGroupDialog>
      </>
    );
  });
